import type { useForm } from "hooks";
import type { BootstrapableForm } from "types";
import type { PaymentMethod } from "features/ecommerce/types";
import type { OnboardingFormProps } from "ui/forms/ECommerce/Onboarding/types";

export const enum FormField {
    Methods = 'methods',
    OtherMethods = 'otherMethods'
};

export type OnboardingPaymentMethods = {
    readonly [FormField.Methods]: Array<string>;
    readonly [FormField.OtherMethods]: string;
};

export type OnboardingPaymentMethodsBootstrapData = {
    readonly [FormField.Methods]: Array<PaymentMethod>;
};

export type OnboardingPaymentMethodsForm = Omit<
    BootstrapableForm<OnboardingPaymentMethods, OnboardingPaymentMethodsBootstrapData>,
    | 'initialValues'
> & {
    readonly initialValues: OnboardingPaymentMethods;
};

export type OnboardingPaymentMethodsProps =
    & OnboardingFormProps
    & OnboardingPaymentMethodsForm
    & ReturnType<typeof useForm<OnboardingPaymentMethods>>;
